function CalculateNetAmount(tot, vat, dis) {
  let t = parseFloat(tot);
  let v = parseFloat(vat);
  let d = parseFloat(dis);
  return t + v - d;
}

export { CalculateNetAmount };
